import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { sizes } from '../../const/sizes';
const StyledBlurrableContainer = styled('div', ({ $blurred }) => ({
    filter: $blurred ? `blur(${sizes.blurrableContainer.blurFilter})` : 'unset',
}));
export const BlurrableContainer = ({ children, blurred, }) => {
    return (_jsx(StyledBlurrableContainer, { $blurred: blurred, children: children }));
};
